export default {
	styleOverrides: {
		root: ({ theme }) => ({
			backgroundColor: 'transparent',
			boxShadow: 'none',
		}),
	},
}
